import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Button,
  Icon
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import QuoteDiscountsTable from './QuoteDiscountsTable';
import AddDiscounts from './AddDiscounts';


const ButtonSecondary = withStyles({
  root: {
    background: '#F0F0FF',
    border: '1px solid #D9D8FF',
    borderRadius: '4px'
  }
})(Button);


const DiscountOptions = () => {
  const [openAddDiscountModal, setOpenAddDiscountModal] = useState(false);
  const { editableQuoteProduct } = useSelector((state: IReduxState) => state.quote);

  const quoteDiscounts = editableQuoteProduct?.custom_attributes?.find((attr) => attr.attribute_code === 'quotepro_discounts')?.value || '[]';

  const sortedAllDiscounts = JSON.parse(quoteDiscounts)?.sort((a, b) => {
    if (a.price_type < b.price_type) {
      return -1;
    }

    if (a.price_type > b.price_type) {
      return 1;
    }

    return a.price - b.price;
  });

  return (
    <div className="pt-4 pb-2 px-2">
      {!!quoteDiscounts.length &&
        <>
          <div className="my-5">
            <QuoteDiscountsTable
              quoteDiscounts={sortedAllDiscounts}
            />
          </div>
        </>
      }
      <ButtonSecondary
        variant="outlined"
        color="primary"
        className="px-6 font-bold"
        onClick={() => setOpenAddDiscountModal(true)}
      >
        <Icon className="mr-2">add</Icon>
        <span>Add Discounts</span>
      </ButtonSecondary>
      <AddDiscounts
        open={openAddDiscountModal}
        onClose={setOpenAddDiscountModal}
      />
    </div>
  );
};

export default DiscountOptions;
